// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"e2a5a13c","967":"f3f6aad6"}[chunkId] + ".chunk.js";
};